import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  lookups$: BehaviorSubject<any>;

  constructor(private http: HttpClient) {
    this.lookups$ = new BehaviorSubject(null);
  }

  loadLookups() {

    this.lookups$.next({"loading":true,data:[]});
    const params = new HttpParams().set('filter', 'regions');
    this.http.get("/api/data/accountsfilters",{ params }).subscribe(
      (response: any) => {
        const rtn = response;
        this.lookups$.next({"loading":false,data:rtn});
      }, (error: any) => {
        window.location.href = "/login"
        console.log('unable to get lookups');
        console.log(error);
      }
    );
  }

}
